<section class="container page-section-one">
    <div class="row payment-result-cases align-items-center pb-5 pt-2">
        <div class="col-md-6 offset-md-3 offset-0 text-center">
            <fa-icon [icon]="faTimesCircle" class="text-danger"></fa-icon>
            <h4>Pago no completado</h4>
            <p class="mb-1">Lo sentimos, su pago no se ha completado.</p>
            <p>Vuelva a intentarlo o pruebe más tarde.</p>
            <a [routerLink]="linkTo" class="btn btn-primary">Volver</a>
        </div>
    </div>
</section>
